module.exports = __webpack_public_path__ + "img/15.d7b548e4.jpg";